import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from "@angular/core";

import { NgFor } from "@angular/common";
import { SlickCarouselModule } from "ngx-slick-carousel";
import Swiper from "swiper";
import { API_URLS, FILE_PATH_TESTIMONIAL } from "../../../config/app.constants";
import { HttpinterceptorService } from "../../../shared/services/httpinterceptor.service";

@Component({
  selector: "app-testimonials",
  templateUrl: "./testimonials.component.html",
  styleUrls: ["./testimonials.component.scss"],
  standalone: true,
  imports: [SlickCarouselModule, NgFor],
})
export class TestimonialsComponent implements OnInit {
  // home testimonial slider
  @ViewChild("swiperCoverflowContainer") swiperCoverflowContainer: ElementRef;

  slides: any[];
  imagePath = FILE_PATH_TESTIMONIAL;

  constructor(
    private http: HttpinterceptorService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.getTestimonialsList();
  }

  ngAfterViewInit(): void {
    // Called after ngAfterContentInit when the component's view has been initialized.
    // Applies to components only.
    // Add 'implements AfterViewInit' to the class.
    // Ensure Swiper is initialized after data is fetched
    if (this.slides && this.slides.length > 0) {
      this.initSwiper();
    }
  }

  initSwiper() {
    new Swiper(this.swiperCoverflowContainer.nativeElement, {
      // Swiper configuration options here
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: "auto",
      loop: true,
      effect: "coverflow",
      initialSlide: 2,
      speed: 1000,
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        modifier: 4,
        slideShadows: false,
      },

      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      breakpoints: {
        320: {
          coverflowEffect: {
            depth: 100,
          },
        },
        768: {
          coverflowEffect: {
            depth: 320,
          },
        },
        992: {
          coverflowEffect: {
            depth: 175,
          },
        },
        1200: {
          coverflowEffect: {
            depth: 100,
          },
        },
      },
    });
  }

  // function API for get all testimonials list
  getTestimonialsList() {
    this.http
      .post(API_URLS.GET_TESTIMONIALS_LIST, {}, false)
      .subscribe((response) => {
        if (response.type === "success") {
          if (response.data) {
            this.slides = response.data;
            this.cdr.detectChanges();
            this.initSwiper();
          }
        }
      });
  }
  onSlidePrev() {
    this.swiperCoverflowContainer.nativeElement.swiper.slidePrev(1000);
  }
  onSlideNext() {
    this.swiperCoverflowContainer.nativeElement.swiper.slideNext(1000);
  }
}
